import moment from 'moment';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';

import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';

export const PARKED = 'PARKED';
export const NOT_TRIAL = 'NOT_TRIAL';
export const EXPIRED = 'EXPIRED';

export const TrialServiceModule = angular
    .module('app.components.trial.trialService', [
        SubscriptionServiceModule
    ]).service('trialService', (
        subscriptionsService,
        $q
    ) => {
        function getTrialStatus() {
            return getSubscription().then(subscription => getTrialStatusFromSubscription(subscription));
        }

        function getTrialStatusFromSubscription(subscription) {
            return isTrialPlan(subscription).then((isTrial) => {
                if (isTrial) {
                    let currentUnixTimestamp = moment().unix();
                    if (moment(currentUnixTimestamp).isAfter(subscription.trial_end)) return EXPIRED;
                    let timeRemainingInTrial = moment.unix(subscription.trial_end).fromNow(true);
                    return timeRemainingInTrial;
                }
                return isParkedPlan(subscription).then((isParked) => {
                    return isParked ? PARKED : NOT_TRIAL;
                });
            });
        }

        function isValidTrialPlanStatus(trialStatus) {
            if (isUndefined(trialStatus) || isNull(trialStatus) || trialStatus === '') {
                return false;
            }
            switch (trialStatus) {
                case NOT_TRIAL:
                case PARKED:
                case EXPIRED:
                    return false;
                default:
                    return true;
            }
        }

        function isTrialPlan(preFetchedSubscription) {
            return getSubscription(preFetchedSubscription).then((subscription) => {
                return !!(subscription.plan &&
                          subscription.plan.name === 'Trial Plan' &&
                          isTrialTimestampValid(subscription.trial_start) &&
                          isTrialTimestampValid(subscription.trial_end
                          ));
            });
        }

        function isTrialTimestampValid(trialTimestamp) {
            return angular.isDefined(trialTimestamp)
                && trialTimestamp !== null
                && typeof trialTimestamp !== 'object'
                && moment(trialTimestamp).isValid();
        }

        function isParkedPlan(preFetchedSubscription) {
            return getSubscription(preFetchedSubscription).then((subscription) => {
                return subscription.plan.id === process.env.PARKED_PLAN_ID;
            });
        }

        function getSubscription(preFetchedSubscription) {
            if (preFetchedSubscription) return $q.resolve(preFetchedSubscription);
            return subscriptionsService.getSubscription().then(subscription => subscription);
        }

        return {
            getTrialStatus,
            isTrialPlan,
            isValidTrialPlanStatus,
            isTrialTimestampValid,
            isParkedPlan,
            getSubscription,
            getTrialStatusFromSubscription
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/trial/trial.service.js